module.exports = __webpack_public_path__ + "img/main_banner.9163abcd.jpg";